import { BotId, BotMetadata } from '@feedyou/schema'
import _ from 'lodash'
import { createSelector } from 'reselect'
import { endpointHelpers } from '../endpointHelpers'

export const botMetadataSelector = _.memoize((id: BotId | undefined) => {
  return createSelector(
    endpointHelpers.getBotsMetadata.selectData(), // I <3 PRETTIER
    (data): BotMetadata | undefined => data?.metadata?.find(metadata => metadata.id === id)
  )
})
